<template>
  <div class="custom-rating-date">
    <div class="timepicker-inputs">
      <div>
        <span class="from-to-label" v-if="dateModel.value">{{
          field.is_mandatory && !field.is_optional
            ? field.name
            : field.name + ` ${$t("common.optionalWithBrackets")}`
        }}</span>
        <date-picker
          id="from_time"
          class="pre-reg-datepicker timepicker-width"
          :class="{ 'selected-date-value': dateModel.value }"
          :first-day-of-week="1"
          value-type="format"
          format="DD/MM/YYYY"
          @input="updateDatePicker"
          :placeholder="
            field.is_mandatory && !field.is_optional
              ? field.name
              : field.name + ` ${$t('common.optionalWithBrackets')}`
          "
          v-model="dateModel.value"
        >
          <i slot="icon-calendar" style="padding-inline-end: 10px">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="#787878"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
              />
            </svg>
          </i>
        </date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  props: {
    field: {},
  },
  data() {
    return {
      dateModel: null,
    };
  },
  beforeMount() {
    this.dateModel = cloneDeep(this.field);
  },
  methods: {
    updateDatePicker() {
      this.$emit("updateDatePicker", this.dateModel);
    },
  },
};
</script>
<style lang="scss">
.custom-rating-date {
  width: 416px !important;
  span.from-to-label {
    position: absolute;
    color: #103f5e;
    margin-top: 9px;
    margin-inline-end: 0;
    margin-bottom: 0;
    margin-inline-start: 17px;
    z-index: 2;
    font-size: 12px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
  }
  .selected-date-value {
    input.mx-input {
      padding-inline-start: 15px !important;
      padding-top: 28px !important;
    }
  }
  .timepicker-inputs {
    position: relative;
  }
  .timepicker-width {
    width: 416px !important;
    height: 55px !important;
  }
  .pre-reg-datepicker {
    input.mx-input::placeholder {
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      letter-spacing: 0.25px;
      padding-inline-start: 5px;
      color: #787878;
    }
    .mx-input:disabled {
      &::placeholder {
        color: #787878;
      }
    }

    input.mx-input {
      background-color: #f2f2f2 !important;
      border: none !important;
      border-radius: 4px !important;
      height: 55px !important;
      font-style: normal;
      font-weight: 700 !important;
      font-size: 16px !important;
      line-height: 17px !important;
      width: 416px !important;
      letter-spacing: 0.25px;
      color: #4a4a4a !important;
    }

    .mx-input-wrapper {
      padding: 0px !important;
    }
  }
  .selected-date-value {
    input.mx-input {
      padding-inline-start: 15px !important;
      padding-top: 28px !important;
    }
  }
}
</style>
